import { call, put, takeEvery } from 'redux-saga/effects';
import {
  bigCommerceActionCreators,
  BigCommerceApiKeys,
  FetchBigCommerceShipMethods,
  IBigCommerceShipTypeMap
} from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { uiActionCreators } from '../../ui';
import * as api from '../bigCommerceApi';

function* fetchBigCommerceShipMethods(action: FetchBigCommerceShipMethods) {
  yield put(uiActionCreators.toggleLoading('bigCommerceShipMethods'));
  const response: IApiExecuteRespone<IBigCommerceShipTypeMap[]> = yield call(api.fetchBigCommerceShipMethods);

  if (!response.requestFailed && response.value) {
    yield put(bigCommerceActionCreators.setShipMethods(response.value));
  } else {
    // TODO - show error message
  }

  yield put(uiActionCreators.toggleLoading('bigCommerceShipMethods'));
}

export function* watchFetchBigCommerceShipMethods() {
  yield takeEvery(BigCommerceApiKeys.FETCH_BIG_COMMERCE_SHIP_METHODS, fetchBigCommerceShipMethods);
}
